
angular.module('controllers').controller('modelsHomeCtrl', function ($window) {
    $window.document.title = "Models";
});
